<template>
    <HeaderComponent title="Edit User" :actions="[
        {label: 'Reset Password', click: resetPassword, class: 'bg-yellow-500 text-white'},
        {label: 'Delete User', click: deleteUser, class: 'bg-red-500 text-white'},
        {label: 'Update User', click: updateUser, class: 'bg-blue-500 text-white'},
    ]"/>
    <FormKit
        type="form"
        submit-label="Update User"
        :actions="false"
        @submit="updateUser"
    >
        <FormKit
            type="text"
            name="full_name"
            label="Full Name"
            v-model="user.full_name"
        />
        <FormKit
            type="text"
            name="username"
            label="Username"
            v-model="user.username"
        />
        <FormKit
            type="checkbox"
            name="is_admin"
            label="Is Admin"
            v-model="user.is_admin"
        />
        <div class="formkit-wrapper">
            <label class="block text-slate-700 text-base font-bold dark:text-slate-300 mb-1.5 formkit-label" for="input_1">Affiliates</label>
            <Multiselect
            v-model="userAffiliate"
            :options="affiliates"
            :multiple="false"
                label="name"
                track-by="id"
                class="mb-4"
            />
        </div>
    </FormKit>
</template>

<script setup>
import { usePage, router } from "@inertiajs/vue3";
import { computed } from "vue";
import { FormKit } from "@formkit/vue";
import Multiselect from "vue-multiselect";
import { toast } from "vue3-toastify";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const user = computed(() => page.props.user);
const affiliates = computed(() => page.props.affiliates);

const userAffiliate = computed({
    get() {
        return Object.values(user.value.affiliates)[0] ?? null;
    },
    set(newVal) {
        user.value.affiliates = [newVal];
    }
});

const updateUser = () => {
    router.post(
        `/admin/users/edit/${user.value.id}`,
        {
            user: user.value,
        },
        {
            headers: {
                "X-CSRF-Token": page.props.csrfToken,
            },
        },
    );
};
const deleteUser = () => {
    if (!confirm("Are you sure you want to delete this user?")) return;

    router.delete(`/admin/users/delete/${user.value.id}`, {
        headers: {
            "X-CSRF-Token": page.props.csrfToken,
        },
    });
};
const resetPassword = () => {
    fetch("/users/forgot-password", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": page.props.csrfToken,
        },
        body: JSON.stringify({
            username: user.value.username,
        }),
    }).then((res) => {
        toast("Reset password email sent", {
            type: "success",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
        });
    });
};
</script>
